import { Icon } from "../Icon";
import { IIcon } from "../interfaces/IIcon";

// Legacy icon yet to be normalised to a 64 viewBox, ignoring rule for now.
// eslint-disable-next-line @pebblepad/icon-is-valid
export const heartIcon: IIcon = new Icon(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 10"><path fill-rule="evenodd" d="M5.5 1.509C4.057-1.001 0-.268 0 2.876c0 2.07 2.39 4.293 5.117 6.967a.545.545 0 0 0 .766 0C8.621 7.159 11 4.946 11 2.876 11-.278 6.932-.982 5.5 1.51Z"/></svg>`
);
